module.exports = __webpack_public_path__ + "01c4359d09ba1971f7dc23201bcfd7b7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-25.png
// module id = 2167
// module chunks = 0